import type { CityConfig } from "../city-template/types";

export const centennialConfig: CityConfig = {
  city: "Centennial",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "centennial",
  route: "/centennial",
  title: "Emergency Passport Centennial, CO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Centennial, Colorado — as fast as 24 hours. Same-day courier processing for Centennial, Greenwood Village, Littleton, Englewood, and all Denver Tech Center travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Centennial, CO",
  heroSubtitle: "International business meeting at the Denver Tech Center and your passport is expired? Corporate trip to Europe next week? We help Centennial residents — from DTC executives to Willow Creek families to Foxridge professionals — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than other passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Centennial%20Colorado%20modern%20suburban%20landscape%20with%20the%20Denver%20Tech%20Center%20skyline%20of%20glass%20office%20towers%20in%20the%20distance%2C%20tree%20lined%20residential%20streets%20with%20well%20maintained%20homes%20and%20manicured%20lawns%2C%20wide%20open%20green%20spaces%20with%20walking%20trails%20and%20community%20parks%2C%20the%20Rocky%20Mountain%20front%20range%20visible%20on%20the%20horizon%20under%20clear%20Colorado%20sky%2C%20professional%20landscape%20photography%20with%20crisp%20natural%20lighting%2C%20no%20visible%20text%20or%20people%2C%20wide%20horizontal%20composition&width=1800&height=700&seq=centennial-hero-001&orientation=landscape",
  heroImageAlt: "Centennial Colorado with Denver Tech Center skyline and Front Range mountain backdrop",
  geoPosition: "39.5849;-104.8767",
  geoPlacename: "Centennial, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Colorado Passport Agency",
    address: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
    distance: "Approximately 10 miles east via Arapahoe Road — about 15 minutes",
  },
  nearbyCitiesZips: [
    { name: "Centennial", zips: "80015, 80016, 80111, 80112, 80121, 80122" },
    { name: "Greenwood Village", zips: "80111, 80121" },
    { name: "Littleton", zips: "80120, 80121, 80122, 80123" },
    { name: "Englewood", zips: "80110, 80111, 80113" },
    { name: "Aurora", zips: "80014, 80015, 80016" },
    { name: "Highlands Ranch", zips: "80126, 80129, 80130" },
    { name: "Lone Tree", zips: "80124" },
    { name: "Parker", zips: "80134, 80138" },
    { name: "Cherry Hills Village", zips: "80111, 80113" },
    { name: "Castle Rock", zips: "80104, 80108" },
    { name: "Foxfield", zips: "80016" },
    { name: "Dove Valley", zips: "80112" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier service for urgent Centennial international business travel and family vacations" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — closest city to the Colorado Passport Agency in Aurora" },
    { icon: "ri-flight-takeoff-line", title: "DEN Airport Proximity", desc: "Just 30 minutes from DEN via E-470 — fastest south metro access to international flights" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from any UPS or FedEx in Centennial, DTC, or Greenwood Village" },
  ],
  internalLinks: [
    { name: "Expedited passport in Denver, CO", route: "/denver" },
    { name: "Emergency passport help in Littleton, CO", route: "/littleton" },
    { name: "Fast passport renewal for DTC professionals", route: "/centennial" },
    { name: "Urgent passport services for Greenwood Village", route: "/centennial" },
    { name: "Colorado passport services overview", route: "/colorado" },
    { name: "Passport courier services in Arapahoe County", route: "/centennial" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Centennial remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Centennial is the closest major city to the Colorado Passport Agency in Aurora — just 10 miles — but our courier service means you never need to take time off work for the drive.",
  fpcOfficeAddress: "370 17th St, Denver, CO 80202",
  fpcOfficeDistance: "Serving all of Arapahoe County including Centennial, the Denver Tech Center, Greenwood Village, and surrounding communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Centennial and the DTC corridor. From the Denver Tech Center to Willow Creek, from Foxridge to Castlewood — we serve every neighborhood in Centennial and the surrounding business communities.",
  nearbyCitiesIntro: "We serve Centennial and all nearby Arapahoe County communities including Greenwood Village, Littleton, Englewood, Aurora, Highlands Ranch, Lone Tree, and Parker. We also serve Cherry Hills Village, Foxfield, and Dove Valley.",
  howItWorksIntro: "Most Centennial travelers complete everything online and ship documents via overnight courier. Our registered couriers handle the State Department delivery — no need to drive 10 miles east to the Colorado Passport Agency, even though it's close.",
  mistakesIntro: "Centennial is a major business hub with the Denver Tech Center and frequent international business travel. Here are the most common passport mistakes we see from Centennial-area professionals and families.",
  testimonialsIntro: "Centennial travelers — from DTC executives to Willow Creek families to Greenwood Village professionals — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Centennial, CO? Here are the most common ones we hear from DTC and Arapahoe County travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Colorado Vital Records (Birth, Death, Marriage)", href: "https://cdphe.colorado.gov/certificates-and-records" },
    { label: "Arapahoe County Clerk & Recorder", href: "https://www.arapahoeco.gov/your_county/county_departments/clerk_and_recorder/index.php" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Aurora (15 minutes each way)", "Limited appointments — book 2 weeks ahead"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Aurora drive required — ship from Centennial", "Perfect for international business travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned corporate travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Centennial professionals with immediate business travel needs — as fast as 24 hours. Our couriers provide the fastest passport service without taking time off work driving to Aurora.",
      bullets: ["24–48 hour turnaround available", "DEN departure support", "International business travel expertise"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Centennial adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle everything.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Centennial address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Centennial residents and DTC-area professionals — including new U.S. citizens and young adults.",
      bullets: ["Acceptance facility scheduling in Centennial or Greenwood Village", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Centennial residents who lost their passport before international business travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Centennial and Arapahoe County families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Centennial and Arapahoe County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Centennial CO", description: "Urgent passport processing for Centennial Colorado travelers with immediate departure needs from DEN." },
    { name: "Expedited Passport Renewal Centennial CO", description: "Fast passport renewal for Centennial Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Centennial CO", description: "New passport application services for Centennial Colorado residents applying for their first passport." },
    { name: "Child Passport Centennial CO", description: "Minor passport services for Centennial Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "Mark T.",
      location: "Centennial, CO — Denver Tech Center",
      rating: 5,
      text: "International client meeting in London with 4 days notice. Fast Passport Center got my renewal done in 2 days. Shipped from the UPS Store right in DTC and never missed a beat at work.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Rachel S.",
      location: "Centennial, CO — Willow Creek",
      rating: 5,
      text: "Family trip to Japan with corporate relocation support. Four passports — all renewals. Processed in 4 days. The daily status updates gave us complete peace of mind during a hectic time.",
      service: "Family Passport Bundle",
    },
    {
      name: "David L.",
      location: "Greenwood Village, CO",
      rating: 5,
      text: "M&A due diligence trip to Frankfurt with 5 days before departure. Fast Passport Center handled it in 2 days. Absolutely critical for my business — couldn't have done it without them.",
      service: "Emergency Passport",
    },
    {
      name: "Jennifer K.",
      location: "Centennial, CO — Foxridge",
      rating: 5,
      text: "Lost my passport during a corporate retreat in Vail with an Asia trip coming up. Replacement in 48 hours. The courier service is worth every penny for busy professionals.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "cen-1",
      name: "Centennial Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7420 S Fraser St",
      city: "Centennial",
      state: "CO",
      zip: "80112",
      phone: "(303) 649-0332",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Central Centennial, near Arapahoe Road and I-25",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Centennial acceptance facility. Good parking. Popular location near the Denver Tech Center — book early.",
      icon: "ri-mail-line",
    },
    {
      id: "cen-2",
      name: "Greenwood Village Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6050 S Greenwood Plaza Blvd",
      city: "Greenwood Village",
      state: "CO",
      zip: "80111",
      phone: "(303) 220-0368",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Greenwood Village, near the Denver Tech Center and I-25",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for DTC professionals. Extended hours. Modern facility in the heart of the Greenwood Village business district.",
      icon: "ri-mail-line",
    },
    {
      id: "cen-3",
      name: "Englewood Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3330 S Broadway",
      city: "Englewood",
      state: "CO",
      zip: "80113",
      phone: "(303) 789-0860",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Englewood, approximately 5 miles northwest of Centennial",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative for west Centennial residents. Extended hours and good availability.",
      icon: "ri-mail-line",
    },
    {
      id: "cen-4",
      name: "Aurora Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "18555 E Smoky Hill Rd",
      city: "Aurora",
      state: "CO",
      zip: "80015",
      phone: "(303) 617-8018",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Aurora, approximately 5 miles east of Centennial",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves east Centennial and Aurora residents. Proximity to the Colorado Passport Agency. Large facility with good availability.",
      icon: "ri-mail-line",
    },
    {
      id: "cen-5",
      name: "Arapahoe County Clerk — Centennial",
      type: "County Clerk Passport Acceptance",
      address: "6954 S Lima St",
      city: "Centennial",
      state: "CO",
      zip: "80112",
      phone: "(303) 795-4200",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Centennial, in the Arapahoe County Administration complex",
      website: "https://www.arapahoeco.gov/",
      websiteLabel: "Arapahoe County Clerk",
      notes: "County clerk passport acceptance. Extended hours compared to post office. Full-service county office with DMV and passport services in one location.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 15-min drive to Aurora", fpc: "No — ship from Centennial" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Business Travel", agency: "No special accommodations", fpc: "Guaranteed turnaround for corporate schedules" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Not Checking Passports Before Accepting International Assignments",
      description: "DTC professionals often accept international business trips without verifying their passport validity. Routine processing takes 8–11 weeks. Start expedited service the moment you know about an international trip.",
    },
    {
      icon: "ri-image-line",
      title: "Using Outdated or Non-Compliant Photos",
      description: "Passport photos must be exactly 2×2 inches with a white background and taken within 6 months. Corporate headshots and old photos are often rejected — use a professional passport photo service.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Visa and Entry Requirements",
      description: "Business travelers to India, China, Brazil, and other non-visa-waiver countries need both a passport AND a visa. Start the visa process immediately after receiving your passport to avoid delays.",
    },
    {
      icon: "ri-alert-line",
      title: "Damaged Passport Pages",
      description: "Frequent business travelers often have passports with worn pages, water damage, or loose binding. A damaged passport is invalid and cannot be renewed — you must apply for a new one using form DS-11.",
    },
    {
      icon: "ri-calendar-line",
      title: "Underestimating Peak Processing Times",
      description: "Passport demand spikes in summer and before the holiday season. DTC business travel doesn't stop during these periods. Submit applications at least 4–6 weeks before any planned international travel.",
    },
    {
      icon: "ri-file-list-line",
      title: "Using Wrong Renewal Form for Business Passports",
      description: "If your passport was issued more than 15 years ago, was issued when you were under 16, or is damaged, you cannot use the DS-82 renewal form. You must apply in person using DS-11.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your DTC office or Centennial home." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Centennial or Greenwood Village." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for DTC business documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — no Arapahoe Road drive to Aurora required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Centennial address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Centennial, CO?", a: "Fast Passport Center offers emergency passport processing in Centennial, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — you never need to leave your DTC office for the 10-mile drive to the Colorado Passport Agency in Aurora." },
    { q: "Does Centennial have its own passport agency?", a: "No — Centennial does not have a regional passport agency. The nearest is the Colorado Passport Agency (just 10 miles east via Arapahoe Road in Aurora). Fast Passport Center's courier service means DTC professionals never need to take time off work for the drive." },
    { q: "Can you handle rush passports for corporate travelers?", a: "Yes — corporate rush passport service is one of our specialties in Centennial. We understand that DTC business travel is often unpredictable with short notice. We can process emergency and expedited passports with guaranteed turnaround times to match your corporate travel schedule." },
    { q: "What if I work in the Denver Tech Center but live in Aurora, Highlands Ranch, or Littleton?", a: "Absolutely. Fast Passport Center serves all of Arapahoe County and the entire south metro area including Greenwood Village, Littleton, Englewood, Highlands Ranch, Lone Tree, Parker, and Aurora. We can deliver your passport to whichever address is most convenient — home or office." },
    { q: "How fast is expedited passport processing for business travelers in Centennial?", a: "Our most popular service provides 2–9 business day turnaround. For true emergencies, we offer 24–48 hour processing. As a registered U.S. Department of State courier, we have priority access that self-service applicants simply don't have." },
    { q: "How much does an expedited passport cost in Centennial, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a corporate quote based on your team's needs." },
    { q: "Where can I get passport photos near the Denver Tech Center?", a: "Walgreens at Arapahoe and Yosemite offers passport photo services. UPS Store on S Clinton St in Greenwood Village and FedEx Office on Arapahoe Road also provide passport photos. Photos must be 2×2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Centennial Airport (APA) travelers?", a: "Yes. Fast Passport Center serves all Centennial area travelers including private aviation passengers at Centennial Airport (APA). We understand the unique needs of corporate and private jet travelers and can coordinate expedited services to match your departure schedule." },
  ],
  photoLocations: [
    { name: "Walgreens — Arapahoe & Yosemite", address: "7575 S Yosemite St, Centennial, CO 80112", hours: "Mon–Sun: 8AM–10PM", website: "https://www.walgreens.com/storelocator" },
    { name: "UPS Store — Greenwood Village", address: "8000 E Belleview Ave, Greenwood Village, CO 80111", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM", website: "https://locations.theupsstore.com/co/greenwood-village" },
    { name: "FedEx Office — Arapahoe Rd", address: "6870 S University Blvd, Centennial, CO 80122", hours: "Mon–Fri: 7:30AM–7PM, Sat: 9AM–5PM", website: "https://local.fedex.com/en-us/co/centennial" },
    { name: "Walgreens — Parker & Arapahoe", address: "7575 S University Blvd, Centennial, CO 80122", hours: "Mon–Sun: 8AM–10PM", website: "https://www.walgreens.com/storelocator" },
  ],
  dmvLocations: [
    { name: "DMV — Centennial (Arapahoe County)", address: "6954 S Lima St, Centennial, CO 80112", hours: "Mon–Fri: 8AM–5PM", note: "Full-service DMV for Centennial and Arapahoe County residents. REAL ID and driver's license renewals. Same complex as the County Clerk passport office.", featured: true },
    { name: "DMV — Aurora (Arapahoe County)", address: "490 S Chambers Rd, Aurora, CO 80017", hours: "Mon–Fri: 8AM–5PM", note: "Alternative DMV for east Centennial and Aurora residents. REAL ID processing available. Approximately 8 miles from DTC.", featured: false },
  ],
  airports: [
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "28 miles from Centennial via E-470",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport with nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. About 30 minutes from Centennial via E-470 toll road.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: true,
    },
    {
      code: "APA",
      name: "Centennial Airport",
      distance: "4 miles from Centennial city center",
      address: "7800 S Peoria St, Englewood, CO 80112",
      note: "One of the busiest general aviation airports in the U.S. Private jet and charter services available. No commercial passenger flights. Ideal for DTC corporate travelers using private aviation.",
      flightUrl: "https://www.centennialairport.com/",
      flightLabel: "APA Airport Info",
      featured: false,
    },
    {
      code: "COS",
      name: "Colorado Springs Airport",
      distance: "65 miles from Centennial via I-25 south",
      address: "7770 Milton E Proby Pkwy, Colorado Springs, CO 80916",
      note: "Alternative regional airport with domestic connections. About 1 hour south of Centennial.",
      flightUrl: "https://www.flycos.com/",
      flightLabel: "COS Flight Info",
      featured: false,
    },
  ],
};